module.exports = __webpack_public_path__ + "img/23.fa2b8059.png";